<template>
  <v-snackbar v-model="display" :bottom="true"
    >{{ messageToDisplay
    }}<v-btn dark text @click="display = false">
      Close
    </v-btn></v-snackbar
  >
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      display: false
    }
  },
  computed: {
    ...mapState({
      snackbarConfigs: state => state.snackbarConfigs
    }),
    messageToDisplay() {
      return _.isEmpty(this.snackbarConfigs) ? null : _.head(this.snackbarConfigs).message
    }
  },
  watch: {
    messageToDisplay(value) {
      if (!_.isNull(value)) {
        setTimeout(() => {
          this.display = true
        }, 500)
      }
    },
    display(value) {
      if (value === false) {
        this.removeFirstSnackbar()
      }
    }
  },
  methods: {
    async removeFirstSnackbar() {
      await this.$store.dispatch('REMOVE_FIRST_SNACKBAR_CONFIG')
    }
  }
}
</script>
